<template>
  <div>
    <el-input
      v-if="isString"
      type="text"
      v-model="stringValue"
      v-bind="stringAttr"
      :class="stringAttr.showWordLimit ? 'show-word-limit-pad' : ''"
      @change="change"
    />

    <el-button
      :class="{ 'exist-complex-value': existComplexValue }"
      v-else-if="isComplex"
      type="text"
      icon="el-icon-edit"
      @click="click"
    >
      {{ complexTitile }}
    </el-button>

    <el-input-number
      v-else-if="isNumber"
      v-model="num"
      v-bind="numberAttr"
      @change="change"
    />

    <el-date-picker
      v-else-if="isDate"
      v-model="date"
      :clearable="!required"
      format="dd.MM.yyyy"
      value-format="yyyy-MM-dd"
      type="date"
      @change="change"
    />

    <el-select
      v-else-if="isLookUp"
      v-model="lookup"
      :multiple="multiple"
      @change="change"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>

    <span v-else>{{ type.type }}</span>
  </div>
</template>

<script>
import * as systemService from "@/domain/object/system.service";

export default {
  name: "AttributeValueComponent",
  components: {},
  props: {
    attributeId: [String, Number],
    type: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    required: Boolean,
    references: Object
  },
  data() {
    return {
      stringValue: "",
      num: undefined,
      date: undefined,
      lookup: undefined
    };
  },
  computed: {
    lowerType() {
      return this.type.type.toLowerCase();
    },
    isString() {
      return systemService.isStringType(this.type.type);
    },
    stringAttr() {
      return {
        maxlength: this.type.length ? this.type.length : undefined,
        showWordLimit: this.type.length > 0
      };
    },
    isComplex() {
      return systemService.isComplexType(this.type.type);
    },
    existComplexValue() {
      return (
        this.isComplex &&
        this.value.id &&
        this.value[this.lowerType] &&
        this.isComplexArrayLength(this.value[this.lowerType])
      );
    },
    complexTitile() {
      if (this.isComplex) {
        return this.existComplexValue
          ? this.$t("object_attr_memo_edit")
          : this.$t("object_attr_memo_empty");
      }
      return "";
    },
    isNumber() {
      return systemService.isNumberType(this.type.type);
    },
    numberAttr() {
      let isInt = systemService.isInteger(this.type.type);
      return {
        step: isInt ? 1 : 0.1,
        precision: isInt ? 0 : 2
      };
    },
    isDate() {
      return systemService.isDateType(this.type.type);
    },
    isLookUp() {
      return systemService.isLookUpType(this.type.type);
    },
    options() {
      if (this.isLookUp) {
        if (this.references[this.type.lookUpId]) {
          return this.references[this.type.lookUpId].data;
        }
      }
      return [];
    },
    multiple() {
      return this.isLookUp ? this.type.multiSelect : false;
    }
  },
  methods: {
    isComplexArrayLength(val) {
      if (Array.isArray(val)) {
        return val.length > 0;
      }
      return true;
    },
    change(val) {
      if (
        val === null ||
        val === undefined ||
        val === "" ||
        (Array.isArray(val) && val.length === 0)
      ) {
        // Если хотите удалить, пользуйтесь кнопкой удаления
        this.presetValue();
        return false;
      }

      if (this.isLookUp) {
        if (!Array.isArray(val)) {
          val = [val];
        }
      }

      this.$emit("change", {
        props: this.$props,
        val
      });
    },
    click() {
      this.$emit("click", {
        props: this.$props
      });
    },
    presetValue() {
      if (this.isString) {
        this.stringValue = this.value[this.lowerType];
      } else if (this.isNumber) {
        this.num = this.value[this.lowerType];
      } else if (this.isDate) {
        this.date = this.value[this.lowerType];
      } else if (this.isLookUp) {
        let val = this.value[this.lowerType] || [];
        let arr = Array.isArray(val)
          ? val
          : typeof val === "string"
          ? [Number(val)]
          : [val];
        this.lookup = this.multiple ? arr : arr.length ? arr[0] : undefined;
      }
    }
  },
  mounted() {
    this.presetValue();
  },
  watch: {
    value: function () {
      this.presetValue();
    }
  }
};
</script>

<style lang="scss" scoped></style>
